
import React, { Component } from 'react'
import * as R from 'ramda'
import { connect } from 'react-redux'
import { Link } from 'react-router'

import {List, ListItem} from 'material-ui/List'
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem'
import Divider from 'material-ui/Divider'

import { dirtyRead, doc } from 'selectors/common'

const styles = {
	tabFilled: {

		fontSize: "13px"
	},
	tabEmpty: {
		fontSize: "12px",

		fontStyle: "italic",
		opacity: "0.5"
	},
	inputMob: {
		width: "100%",
		marginLeft: "0px"
	},
	inputDesk: {
		width: "250px",
		marginLeft: "0px"
	}
}

let select = dirtyRead(
	(state, props) => {
		return {
			vendor: doc(state, props.vendorId)
		}
	}
)

export class VendorCard extends Component {
	render(){
		let isMob = typeof global.md.phone() == "string" || (typeof global.md.tablet() == 'string' && window.innerWidth < window.innerHeight)
        let inputField = (isMob)?styles.inputMob:styles.inputDesk
			let vendorId = this.props.vendorId
			return(
				<Link
					className="vandor-card"
					to={`/manager/vendor/${vendorId}`}
					style={{
						textDecoration: 'none'
					}}
				>
					<ListItem
						style={{
							overflow: 'hidden'
						  , paddingLeft: (typeof global.md.phone() == 'string')?"10px":"0"
						  , marginLeft: (typeof global.md.phone() != 'string')?"0":undefined
						  , margin: "0"
						  , textOverflow: "ellipsis"

						}}
						innerDivStyle={{
							padding: "0 15px"
						}}
						className="list-hover"
					>

					<table style={{width: "100%"}}>
						<tbody>
							<tr>
								<td style={{
								    fontSize: "16px"
								  , textOverflow: "ellipsis"
								  , whiteSpace: "nowrap"
								  , overflow: "hidden"
								  , width: '50%'
								  , boxSizing: "borderBox"
								  , padding: '10px 0'
							  }}>{this.props.vendor.firstName}</td>
							  <td style={{
								  fontSize: "16px"
								, textOverflow: "ellipsis"
								, whiteSpace: "nowrap"
								, overflow: "hidden"
								, width: '50%'
								, boxSizing: "borderBox"
								, textAlign: "right"
								, padding: '10px 0'
							  }}>{this.props.vendor.subtype}</td>
							  </tr>
						</tbody>
					</table>
					</ListItem>
				</Link>
			)
	}

}
export default connect(select)(VendorCard)



// WEBPACK FOOTER //
// ./src/routes/manager/propertyForm/vendors/Card.js